// import * as request from 'superagent';
import * as jwt from 'jsonwebtoken';

var IdTokenVerifier = function(configPingOIDC) {
  // async function retrieveKeys() {
  //   const keysResponse = await request.get(configPingOIDC.jwks_uri);
  //   return keysResponse.body.keys;
  // }

  // function formatRSPublicKey(rawKey) {
  //   return [
  //     '-----BEGIN CERTIFICATE-----',
  //     ...rawKey.match(/.{1,64}/g),
  //     '-----END CERTIFICATE-----',
  //   ].join('\n');
  // }

  /**
   * Verify whether token signature and other claims are valid.
   * @param token it token
   * @param options token claims to validate.  (i.e subject, issuer, audience etc )
   * @returns {Promise<*>}
   */
  async function verify(token, options) {
    return new Promise((resolve, reject) => {
      const decoded_token = jwt.decode(token);
      // console.log({ decoded_token, options });
      if (decoded_token) {
        resolve(decoded_token);
      } else {
        reject('Id token verification failed.');
      }
    });
  }

  return {
    verify: verify,
  };
};

export default IdTokenVerifier;



// WEBPACK FOOTER //
// ./src/config/pingOIDC_JWT_Verifier.js